import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {
  ApiResponse,
  PaginatedApiResponse,
} from '@shared/models/api-response.models';
import {
  LoginHistoryItem,
  LoginHistoryQuery,
  OnlineSession,
} from '../models/user-activity.model';

/**
 * The owner's user-activity page: the login history lives in
 * user-management, the live online list in notification-management.
 */
@Injectable({ providedIn: 'root' })
export class UserActivityService {
  private readonly http = inject(HttpClient);

  getLoginHistory(
    query: LoginHistoryQuery
  ): Observable<PaginatedApiResponse<LoginHistoryItem>> {
    const params: Record<string, string> = {
      page: String(query.page),
      limit: String(query.limit),
    };
    if (query.orderBy) params['orderBy'] = query.orderBy;
    if (query.order) params['order'] = query.order;
    if (query.userId) params['userId'] = query.userId;
    if (query.outcome) params['outcome'] = query.outcome;
    if (query.from) params['from'] = query.from;
    if (query.to) params['to'] = query.to;

    return this.http.get<PaginatedApiResponse<LoginHistoryItem>>(
      `${environment.userManagementApiUrl}/api/auth/v1/login-history`,
      { params }
    );
  }

  getOnlineSessions(): Observable<ApiResponse<OnlineSession[]>> {
    return this.http.get<ApiResponse<OnlineSession[]>>(
      `${environment.notificationManagementApiUrl}/api/presence`
    );
  }
}
